import { render } from "./HomeAndRedirectPage.vue?vue&type=template&id=02e71132"
import script from "./HomeAndRedirectPage.vue?vue&type=script&lang=js"
export * from "./HomeAndRedirectPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__